
export class EntBreedingFarmFilter {


  name: string | null = null;
  farmsStatusId: number | null = null;
  animalBreedIds: number[] | null = null;
  animalTypeIds: number[] | null = null;
  areaIds: number[] | null = null;
  regionIds: number[] | null = null
  ownerId: number | null = null;
  address: string | null = null;
  createdFrom: string | null = null;
  createdTo: string | null = null;
  deleted: boolean = false;
  page: number = 1;
  size: number = 30;
}

